(() => {
  if (window.initializeMobileFeatureCarousels) {
    window.initializeMobileFeatureCarousels();
    return;
  }
  function init(root) {
    if (root.dataset.ready) return;
    const track = root.querySelector('[data-track]');
    const items = [...root.querySelectorAll('[data-item]')];
    const dots = [...root.querySelectorAll('[data-dot]')];
    if (!items.length) return;
    root.dataset.ready = 'true';
    let index = 0;
    let frame;
    let settleTimer;
    let slides = items;
    const padding = () => parseFloat(getComputedStyle(track).paddingLeft) || 0;
    const positionOf = (item) => item.offsetLeft - track.offsetLeft - padding();
    const nearest = () => slides.reduce((best, item, i) =>
      Math.abs(positionOf(item) - track.scrollLeft) < Math.abs(positionOf(slides[best]) - track.scrollLeft) ? i : best, 0);
    const updateDots = () => dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === index);
      dot.setAttribute('aria-current', String(i === index));
    });
    let notifiedIndex = -1;
    const notifyChange = () => {
      if (notifiedIndex === index) return;
      notifiedIndex = index;
      root.dispatchEvent(new CustomEvent('feature-carousel:change', { bubbles: true }));
    };
    const sync = () => {
      index = (nearest() - (items.length > 1 ? 1 : 0) + items.length) % items.length;
      updateDots();
      notifyChange();
    };
    if (items.length > 1) {
      const clone = (item) => {
        const copy = item.cloneNode(true);
        copy.removeAttribute('data-item');
        copy.removeAttribute('data-shopify-editor-block');
        copy.setAttribute('aria-hidden', 'true');
        copy.setAttribute('inert', '');
        copy.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
        return copy;
      };
      track.insertBefore(clone(items[items.length - 1]), items[0]);
      track.appendChild(clone(items[0]));
      slides = [...track.children];
      if (root.getClientRects().length) track.scrollLeft = positionOf(items[0]);
    }
    const settle = () => {
      if (items.length < 2 || !root.getClientRects().length) return;
      const current = nearest();
      if (current !== 0 && current !== slides.length - 1) return;
      const destination = current === 0 ? items[items.length - 1] : items[0];
      const snap = track.style.scrollSnapType;
      track.style.scrollSnapType = 'none';
      track.scrollLeft = positionOf(destination);
      track.style.scrollSnapType = snap;
      sync();
    };
    const go = (i) => {
      if (!root.getClientRects().length) return;
      index = (i + items.length) % items.length;
      const physical = nearest();
      const target = i < 0 && physical === 1 ? slides[0]
        : i >= items.length && physical === items.length ? slides[slides.length - 1]
        : items[index];
      track.scrollTo({ left: positionOf(target), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      updateDots();
      notifyChange();
    };
    root.querySelector('[data-prev]')?.addEventListener('click', () => go(index - 1));
    root.querySelector('[data-next]')?.addEventListener('click', () => go(index + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => go(i)));
    root.addEventListener('feature-carousel:select', (event) => {
      if (Number.isInteger(event.detail?.index) && event.detail.index >= 0 && event.detail.index < items.length) {
        go(event.detail.index);
      }
    });
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(sync);
      clearTimeout(settleTimer);
      settleTimer = setTimeout(settle, 150);
    }, { passive: true });
    track.addEventListener('scrollend', settle);
    window.addEventListener('resize', () => {
      clearTimeout(settleTimer);
      if (root.getClientRects().length) track.scrollLeft = positionOf(items[index]);
    });
    track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        go(index + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    root.closest('.shopify-section')?.addEventListener('shopify:block:select', (event) => {
      const item = event.target.closest('[data-item]');
      if (item && items.includes(item)) go(items.indexOf(item));
    });
    if (root.getClientRects().length) sync();
    else updateDots();
  }
  const initialize = (scope = document) => scope.querySelectorAll('[data-mobile-feature-carousel]').forEach(init);
  window.initializeMobileFeatureCarousels = initialize;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
